/**
 * @generated SignedSource<<772550bac739da8389d7a484c2b79840>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersCheckAnnouncementArticle$data = {
  readonly sectionsV2: ReadonlyArray<{
    readonly value: ReadonlyArray<{
      readonly entityId?: string;
    } | null | undefined> | null | undefined;
  } | null | undefined> | null | undefined;
  readonly " $fragmentType": "helpersCheckAnnouncementArticle";
};
export type helpersCheckAnnouncementArticle$key = {
  readonly " $data"?: helpersCheckAnnouncementArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckAnnouncementArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersCheckAnnouncementArticle"
};

(node as any).hash = "b621c7627e8381176e9e6c88801b2d7a";

export default node;
